export const iconFontAwesomeDisasterCrisisTornado = (
	<i className="fa-solid fa-tornado"></i>
);
